import { Box, Card, Typography, IconButton, CircularProgress } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import dictionary from "../../Mobx/Dictionary";
import imageStore from "../../Mobx/Images";
import urls from "../../Mobx/Urls";
import additionalInfo from "../../Mobx/AdditionalInfo";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";

const ImageCard = ({ word, index, isSelected, onClick }) => {
    const [imageSize, setImageSize] = useState({ width: null, height: null });

    const additionalInfoId = word.additionalInfo;
    const wordImages = additionalInfoId ? imageStore.imagesMap[additionalInfoId] || [] : [];
    const defaultImage = wordImages.find(img => img.default) || wordImages[0];

    useEffect(() => {
        if (defaultImage?.fileName) {
            const img = new Image();
            img.onload = () => setImageSize({ width: img.width, height: img.height });
            img.src = `${urls.file.getImage}${defaultImage.fileName}`;
        }
    }, [defaultImage]);

    const isInvalidSize =
        imageSize.width !== null &&
        imageSize.height !== null &&
        !(
            (imageSize.width === 1024 && imageSize.height === 1024) ||
            (imageSize.width === 886 && imageSize.height === 886)
        );

    const is886Size =
        imageSize.width === 886 && imageSize.height === 886;

    return (
        <Card
            sx={{
                width: "100%",
                height: "100%",
                border: isSelected ? "2px solid #1976d2" : "1px solid #ccc",
                boxShadow: isSelected ? "0 6px 16px rgba(0,0,0,0.2)" : "0 2px 6px rgba(0,0,0,0.12)",
                borderRadius: 2,
                padding: 2,
                display: "flex",
                flexDirection: "column",
                position: "relative",
                backgroundColor: is886Size
                    ? "#d4edda" // ירוק בהיר
                    : isInvalidSize
                        ? "#ffb3b3" // אדום
                        : isSelected
                            ? "#f5faff" // כחול בהיר
                            : "#fff", // לבן
                transition: "all 0.15s ease-in-out"
            }}
        >
            {/* מספר סידורי */}
            <Box sx={{ position: "absolute", top: 1, right: 8 }}>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.8rem" }}>
                    {index + 1}
                </Typography>
            </Box>

            {/* כפתור הצגה/הסתרה */}
            {defaultImage && (
                <Box sx={{ position: "absolute", top: 1, left: 1 }}>
                    <IconButton
                        sx={{ bgcolor: "rgba(255,255,255,0.7)", maxHeight: 35, maxWidth: 35 }}
                        onClick={async () => {
                            const newHidden = !defaultImage.hidden;
                            await additionalInfo.updateExistsInfo(
                                additionalInfoId,
                                "images",
                                defaultImage._id,
                                { hidden: newHidden }
                            );
                        }}
                        disabled={additionalInfo.loading.updateExistsInfo.images?.[defaultImage._id] === "hidden"}
                    >
                        {additionalInfo.loading.updateExistsInfo.images?.[defaultImage._id] === "hidden" ? (
                            <CircularProgress size={19} />
                        ) : (
                            defaultImage.hidden ? <VisibilityOffIcon fontSize="small" sx={{ color: 'error.main' }} /> : <VisibilityIcon fontSize="small" />
                        )}
                    </IconButton>
                </Box>
            )}

            {/* אייקון שגיאה אם הגודל שגוי */}
            {/* {isInvalidSize && (
                <ErrorOutlineIcon
                    color="error"
                    sx={{
                        position: "absolute",
                        top: 1,
                        left: 1,
                        backgroundColor: "#fff",
                        borderRadius: "50%"
                    }}
                />
            )} */}

            {/* טקסט */}
            <Box textAlign="center" sx={{ flexShrink: 0 }}>
                <Typography variant="h6" fontWeight={600} sx={{ direction: /[\u0590-\u05FF]/.test(word.original) ? "rtl" : "ltr" }}>
                    {word.original}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ direction: /[\u0590-\u05FF]/.test(word.trns) ? "rtl" : "ltr" }}>
                    {word.trns}
                </Typography>
                <Typography
                    variant="caption"
                    color="text.disabled"
                    sx={{
                        direction: /[\u0590-\u05FF]/.test(word.pos || "") ? "rtl" : "ltr",
                        minHeight: "1em", // שומר על גובה קבוע
                    }}
                >
                    {word.pos || "\u00A0" /* רווח בלתי נשבר כדי להשאיר מקום */}
                </Typography>
            </Box>

            {/* תמונה */}
            <Box
                sx={{
                    flexGrow: 1,
                    minHeight: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-end"
                }}
            >
                <Box
                    onClick={() => {
                        dictionary.setCurrent(null, null, word._id);
                        onClick();
                    }}
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        borderRadius: 2,
                        transition: "all 0.15s ease-in-out",
                        "&:hover img": {
                            transform: "scale(1.05)",
                        },
                        "&:hover .image-placeholder": {
                            transform: "scale(1.05)",
                        },
                    }}
                >
                    {defaultImage ? (
                        <Box
                            component="img"
                            src={`${urls.file.getImage}${defaultImage.fileName}`}
                            alt="תמונה"
                            sx={{
                                borderRadius: 2,
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                                transition: "transform 0.2s ease-in-out",
                            }}
                        />
                    ) : (
                        <Box
                            className="image-placeholder"
                            width="100%"
                            height="100%"
                            borderRadius={2}
                            bgcolor="#f0f0f0"
                            sx={{
                                transition: "transform 0.2s ease-in-out",
                            }}
                        />
                    )}
                </Box>
            </Box>
        </Card>
    );
};

export default observer(ImageCard);
